import { render, staticRenderFns } from "./AddNumber.vue?vue&type=template&id=1354c680&scoped=true&"
import script from "./AddNumber.vue?vue&type=script&lang=js&"
export * from "./AddNumber.vue?vue&type=script&lang=js&"
import style0 from "./AddNumber.vue?vue&type=style&index=0&id=1354c680&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1354c680",
  null
  
)

export default component.exports